import { useEffect, useState } from "react";
import { Row, Col } from "react-bootstrap";
import Form from "react-bootstrap/Form";

function FechaAndPagoForm({ fecha, setFecha, setFormaDePago }) {

  // Funcion encargada de obtener la fecha de hoy y devolverla formateada.
  function getDate(separator = "-") {
    const newDate = new Date();
    let date = newDate.getDate();
    let month = newDate.getMonth() + 1;
    let year = newDate.getFullYear();

    return `${year}${separator}${
      month < 10 ? `0${month}` : `${month}`
    }${separator}${date < 10 ? `0${date}` : `${date}`}`;
  }

  useEffect(() => {
    // Hacemos un 'setFecha' con la fecha del dia, solo cuando se renderiza el componente
    setFecha(getDate());
  }, []);


  return (
    <>
      <h4>Fecha y Forma de pago:</h4>
      <Row className="d-flex justify-content-around">
        <Form.Group className="m-4" as={Col} lg={3}>
          <Form.Label className="text-primary">Seleccionar fecha</Form.Label>
          <Form.Control
            className="pointer"
            type="date"
            value={fecha}
            onChange={(e) => {
              setFecha(e.target.value);
            }}
          />

        </Form.Group>

        <Form.Group className="m-4" as={Col} lg={3}>

          <Form.Label className="text-primary">Forma de Pago</Form.Label>
          <Form.Select
            className="pointer"
            onChange={(e) => {
              setFormaDePago(e.target.value);
            }}
          >
            <option value={0}>Efectivo</option>
            <option value={2}>Transferencia</option>
            <option value={1}>Tarjeta</option>
            <option value={-1}>Debe</option>
          </Form.Select>
        </Form.Group>

      </Row>

    </>
  );
}
export default FechaAndPagoForm;
